module.exports = __webpack_public_path__ + "img/image46.8da241a4.png";